import moment from "moment";
import { Divider } from "antd";
import { ExtendedMatch } from "../../../../api/types";
import { Row } from "../../../_layout/Flex";

interface Props {
  extendedMatch: ExtendedMatch;
}

const Footer = ({ extendedMatch }: Props) => {
  if (!extendedMatch.match_email_sent) {
    return null;
  }

  const sentTime = moment(extendedMatch.match_email_sent);

  return (
    <>
      <Divider style={{ margin: 0 }} />
      <Row layout={"flex-end center"} style={{ padding: "15px" }}>
        <span style={{ marginRight: "auto" }}>
          {sentTime.format("[Match email sent] M/D [at] h:mm a")}
        </span>
      </Row>
    </>
  );
};

export default Footer;
